/* OfficeType client data model
 *
 * Angular Module: trackerbase-app.models.office-type
 * Injected Factory: OfficeType
 */

import angular from "angular";

import Recipient from "./Recipient";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

class OfficeType {
    constructor(
        officeTypeId,
        officeTypeName,
        officeTypeSortPosition,
        officeTypeOffices,
        officeTypeSubscribers
    )
    {
        if (Number.isInteger(officeTypeId)) {
            this.officeTypeId = officeTypeId;
        }
        else {
            throw new TypeError("Missing or invalid office type id.");
        }

        if ((officeTypeName != null) &&
            (angular.isString(officeTypeName)) &&
            (officeTypeName.length > 0)) {

            this.officeTypeName = officeTypeName;
        }
        else {
            throw new TypeError("Missing or invalid office type name.");
        }

        if (Number.isInteger(officeTypeSortPosition)) {
            this.officeTypeSortPosition = officeTypeSortPosition;
        }
        else {
            throw new TypeError("Missing or invalid office type sort position.");
        }

        this.officeTypeOffices = [];
        if ((officeTypeName != null) &&
            (angular.isArray(officeTypeOffices)))
        {
            Array.prototype.push.apply(
                this.officeTypeOffices,
                officeTypeOffices
            );
        }

        this.officeTypeSubscribers = [];
        if ((angular.isDefined(officeTypeSubscribers)) &&
            (angular.isArray(officeTypeSubscribers)))
        {
            Array.prototype.push.apply(
                this.officeTypeSubscribers,
                officeTypeSubscribers
            );
        }

    }

    toString() {
        return `${this.officeTypeName} (${this.officeTypeId})`;
    }

    valueOf() {
        return this.officeTypeId;
    }

    get displayName() {
        return this.officeTypeName;
    }

    get sortAs() {
        return this.officeTypeSortPosition.toString().padStart(3, "0");
    }

    get subscribableId() {
        return this.officeTypeId;
    }

    static Copy(srcOfficeType) {
        return new OfficeType(
            srcOfficeType.officeTypeId,
            srcOfficeType.officeTypeName,
            srcOfficeType.officeTypeSortPosition,
            srcOfficeType.officeTypeOffices,
            srcOfficeType.officeTypeSubscribers
        );
    }

    static FromServerOfficeType(serverOfficeType, serverOfficeConverterCb) {

        let serverOfficeData = undefined;
        if ((angular.isDefined(serverOfficeConverterCb)) &&
            (angular.isFunction(serverOfficeConverterCb)))
        {
            if ((angular.isDefined(serverOfficeType.Offices)) &&
                (angular.isArray(serverOfficeType.Offices)))
            {
                serverOfficeData = serverOfficeType.Offices.map(function(so) {
                    return serverOfficeConverterCb(so);
                });
            }
        }

        let serverOfficeTypeSubscriberData = undefined;
        if ((angular.isDefined(serverOfficeType.OfficeTypeSubscribers)) &&
            (angular.isArray(serverOfficeType.OfficeTypeSubscribers)))
        {
            serverOfficeTypeSubscriberData = serverOfficeType.OfficeTypeSubscribers.map(function(otSub) {
                return Recipient.FromServerRecipient(otSub);
            });
        }

        return new OfficeType(
            serverOfficeType.OfficeTypeId,
            serverOfficeType.OfficeTypeName,
            serverOfficeType.SortPosition,
            serverOfficeData,
            serverOfficeTypeSubscriberData
        );
    }

}

makePropsEnumerable(OfficeType.prototype, [
    "displayName",
    "sortAs",
    "subscribableId"
]);

export default OfficeType;



//////////////////
// WEBPACK FOOTER
// ./src/models/OfficeType.js
// module id = IkZ8
// module chunks = 1